import { AccountConfigNonStandardProperties } from "./reducers/environments";

/**
 * KEEP THESE SORTED ALPHABETICALLY.
 */
type FeatureFlag =
  | "accountDashboard"
  | "adBlock"
  | "adPerformanceMeta"
  | "allowJsDynamicProp"
  | "analytics"
  | "audiences"
  | "audiencesBackfill"
  | "audiencesIngest"
  | "cdaDashboard"
  | "savedMoneyDashboard"
  | "savedMoneyGamification"
  | "chatSupport"
  | "consentMetrics"
  | "destinationsV2"
  | "disableMasqueradeWarningBanner"
  | "displayNewEventLibraryPage"
  | "emitAppointmentAttributionEvents"
  | "emitAppointmentAttributionEventsMeta"
  | "freshpaintAiChat"
  | "freshpaintConsentManagementUI"
  | "functions"
  | "globalDevicePersistence"
  | "googleAdsEnhancedConversionsPassthrough"
  | "hipaaV2"
  | "identityMatching"
  | "insightsMultiChannelJourneyToggle"
  | "marketingPerformanceAnalysis"
  | "mmp"
  | "networkEventDefs"
  | "personas"
  | "phoneNumberAudiences"
  | "podscribe"
  | "precisionEventsDefaultNotSegmentCompatible"
  | "rbac"
  | "selfServeAuditLog"
  | "simulatedCDAMatching"
  | "sourceFunctions"
  | "sqlTransformations"
  | "sqlTransformationsv2"
  | "traces"
  | "translation"
  | "botBlocking"
  | "unifiedDestinationsUI"
  | "useUnifiedEntryScript"
  | "userProfiles"
  | "webTrackerMonitoring"
  | "webTrackerMonitoringM3"
  | "webTrackerMonitoringTrackerBlockedUI";

/**
 * Get the value of a feature flag
 */
interface FeatureFlagConfigurationLocation {
  config: Partial<
    Record<FeatureFlag, boolean> & AccountConfigNonStandardProperties
  >;
}
export function getFeature(
  accountMetadata: FeatureFlagConfigurationLocation,
  featureFlag: FeatureFlag,
): boolean {
  switch (featureFlag) {
    case "accountDashboard":
    case "adBlock":
    case "adPerformanceMeta":
    case "allowJsDynamicProp":
    case "analytics":
    case "audiences":
    case "audiencesBackfill":
    case "audiencesIngest":
    case "botBlocking":
    case "cdaDashboard":
    case "savedMoneyDashboard":
    case "savedMoneyGamification":
    case "chatSupport":
    case "consentMetrics":
    case "destinationsV2":
    case "disableMasqueradeWarningBanner":
    case "displayNewEventLibraryPage":
    case "emitAppointmentAttributionEvents":
    case "emitAppointmentAttributionEventsMeta":
    case "freshpaintAiChat":
    case "freshpaintConsentManagementUI":
    case "functions":
    case "globalDevicePersistence":
    case "googleAdsEnhancedConversionsPassthrough":
    case "hipaaV2":
    case "identityMatching":
    case "insightsMultiChannelJourneyToggle":
    case "marketingPerformanceAnalysis":
    case "mmp":
    case "networkEventDefs":
    case "personas":
    case "phoneNumberAudiences":
    case "podscribe":
    case "precisionEventsDefaultNotSegmentCompatible":
    case "rbac":
    case "selfServeAuditLog":
    case "simulatedCDAMatching":
    case "sourceFunctions":
    case "sqlTransformations":
    case "sqlTransformationsv2":
    case "traces":
    case "translation":
    case "unifiedDestinationsUI":
    case "useUnifiedEntryScript":
    case "userProfiles":
    case "webTrackerMonitoring":
    case "webTrackerMonitoringM3":
    case "webTrackerMonitoringTrackerBlockedUI":
      return accountMetadata.config[featureFlag] || false;
    default:
      console.warn("Unsupported feature %s requested", featureFlag);
      return false;
  }
}

export default FeatureFlag;
